import { forwardRef } from "react";
import { Input } from "@/components/ui/input";

/**
 * Mobile-friendly numeric input that supports NEGATIVE values.
 * - `type="text"` + `inputMode="decimal"` shows the right keyboard on mobile
 *   AND lets users type a leading "-".
 * - `pattern="-?\\d*\\.?\\d*"` blocks anything that is not a signed decimal.
 *
 * Pass-through props mirror <Input>. Always emits string values via onChange
 * so the parent can `parseFloat(value)` only on submit.
 */
const ALLOWED_RE = /^-?\d*(?:[.,]\d*)?$/;

const NumericInput = forwardRef(function NumericInput(
  { value = "", onChange, allowNegative = true, ...rest },
  ref
) {
  const handleChange = (e) => {
    let next = e.target.value;
    // Normalize comma -> dot for locales where comma is the decimal separator.
    next = next.replace(",", ".");
    if (!allowNegative) next = next.replace("-", "");
    if (next === "" || next === "-" || ALLOWED_RE.test(next)) {
      onChange?.({ ...e, target: { ...e.target, value: next } });
    }
  };

  return (
    <Input
      ref={ref}
      type="text"
      inputMode="decimal"
      autoComplete="off"
      autoCorrect="off"
      spellCheck={false}
      value={value}
      onChange={handleChange}
      {...rest}
    />
  );
});

export default NumericInput;
